exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".boyutSpan[data-v-581b0f88]{width:125px}", ""]);

// exports
